<template>
	<div>
		<breadcrumbs />
		<loading :active.sync="isLoading"></loading>
		<div class="content-i">
			<div class="content-box">
				<div class="row">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">

							</h6>
							<div class="element-box">



							</div>
						</div>

					</div>

					<div class="col-12">
						<div class="element-wrapper">
							<h6 class="element-header">
								{{ t.navigation.session_analytics }}
							</h6>
							<div class="element-box">
								<div class="os-tabs-w">
									<div class="os-tabs-controls">


										<ul class="nav nav-tabs smaller">
											<li class="nav-item active">
												<a class="nav-link" data-toggle="tab" href="#tab_overview">Overview</a>
											</li>

										</ul>
										<ul class="nav nav-pills smaller d-none d-md-flex">
											<li class="nav-item">
												<a class="nav-link" data-toggle="tab" href="#">Today</a>
											</li>
											<li class="nav-item">
												<a class="nav-link active" data-toggle="tab" href="#">7 Days</a>
											</li>
											<li class="nav-item">
												<a class="nav-link" data-toggle="tab" href="#">14 Days</a>
											</li>
											<li class="nav-item">
												<a class="nav-link" data-toggle="tab" href="#">Last Month</a>
											</li>
										</ul>
									</div>
									<div class="tab-content">
										<div class="tab-pane active" id="tab_overview">
											<div class="el-tablo bigger">
												<div class="label">
													{{ t.total_sessions }}
												</div>
												<div class="value">
													{{ sessionTotal | numb }}
												</div>
											</div>
											<div class="el-chart-w">
												<canvas class="chartjs-render-monitor" style="display: block; height: 204px; width: 816px;" ref="canvas"></canvas>
											</div>
										</div>
										<div class="tab-pane" id="tab_sales"></div>
										<div class="tab-pane" id="tab_conversion"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--------------------
START - Sidebar
-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper">
					<div class="element-actions actions-only" v-b-toggle.filter variant="primary">
						<span class="when-opened">
							<i class="os-icon os-icon-minus-circle"></i>
						</span>
						<span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
						</span>
					</div>
					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">
						<b-collapse id="filter" class="mt-2">

						</b-collapse>
					</div>
				</div>

			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>
	</div>
</template>

<script>
	import formatter from '@/mixins/formatter'
    export default {
        name: 'analyticsSession',
	    mixins: [formatter],
        data () {
            return {
                t: this.$root.t,
                isLoading: false,
	            sessionChart: [],
	            sessionTotal: 0
            }
        },
	    mounted () {
          setTimeout( this.fetchSessionChart(), 500);
	    },
	    methods: {
            fetchSessionChart ()
            {
                this.isLoading = true;
                this.$http.get(api+'api/v1/analytics/session/stats?noCache=1')
                    .then(response => {
                    this.sessionChart = response.body.result;
                this.isLoading = false;
                this.initChart()
	            }, response => {
	                this.isLoading = false;
	            })
            },
            initChart ()
            {

                var chartLabel = new Array;
                var chartData = new Array;
                var th = this;
                this.sessionChart.forEach(function(element) {
                    chartLabel.push(new Date(element.label).toLocaleString([]));
                    chartData.push(element.data);
                    th.sessionTotal += element.data;
                });

                var lineChart = this.$refs.canvas;

                // line chart data
                var lineData = {
                    labels: chartLabel,
                    datasets: [{
                        label: "Session",
                        fill: true,
                        lineTension: 0.3,
                        borderColor: "#047bf8",
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: "#fff",
                        pointBackgroundColor: "#141E41",
                        pointBorderWidth: 0,
                        pointHoverRadius: 10,
                        pointHoverBackgroundColor: "#FC2055",
                        pointHoverBorderColor: "#fff",
                        pointHoverBorderWidth: 3,
                        pointRadius: 5,
                        pointHitRadius: 10,
                        data: chartData,
                        spanGaps: true
                    }]
                };

                // line chart init
                var myLineChart = new Chart(lineChart, {
                    type: 'line',
                    data: lineData,
                    options: {
                        legend: {
                            display: false
                        },
                        scales: {
                            xAxes: [{
                                ticks: {
                                    fontSize: '11',
                                    fontColor: '#969da5'
                                },
                                gridLines: {
                                    color: 'rgba(0,0,0,0.05)',
                                    zeroLineColor: 'rgba(0,0,0,0.05)'
                                }
                            }],
                            yAxes: [{
                                display: true,
                                ticks: {
                                    beginAtZero: true,
                                }
                            }]
                        }
                    }
                });
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/analytics/session.vue